import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Label } from 'hui';
import { EventCategories, EventActions } from '../../../constants/Analytics';
import { Link } from 'react-router-dom';

export const TopicLabel = styled(Label)`
  margin-top: 10px;
`;

const TopicLabels = ({ topic, secondaryTopics }) => (
  <div style={{ textAlign: 'center' }}>
    {topic && topic.key && (
      <TopicLabel ghost>
        <Link
          to={`/c/${topic.key}`}
          data-ga-category={EventCategories.ARTICLES}
          data-ga-action={EventActions.TOPIC_LABEL_CLICK_PRIMARY_TOPIC_LINK}
          data-ga-label={`[/c/${topic.key}]`}
        >
          {topic.name}
        </Link>
      </TopicLabel>
    )}
    {secondaryTopics &&
      secondaryTopics.map(secondaryTopic => (
        <TopicLabel key={secondaryTopic.key} ghost>
          <Link
            to={`/c/${secondaryTopic.key}`}
            data-ga-category={EventCategories.ARTICLES}
            data-ga-action={EventActions.TOPIC_LABEL_CLICK_SECONDARY_TOPIC_LINK}
            data-ga-label={`[/c/${secondaryTopic.key}]`}
          >
            {secondaryTopic.name}
          </Link>
        </TopicLabel>
      ))}
  </div>
);

TopicLabels.propTypes = {
  topic: PropTypes.object,
  secondaryTopics: PropTypes.array
};

export default TopicLabels;
